/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-14 17:17:45
 * @FilePath: \mrc-ess-fronted\src\util\naviData.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-29 15:23:38
 */
export default [
  {
    id: 0,
    title: "Dashboard",
    path: "/",
    meta: { icon: "", isSvg: false },
  },
  {
    id: 2,
    title: "Calenndar",
    path: "/calendar",
    meta: { icon: "", isSvg: false },
  },
  {
    id: 201,
    title: "Block Leave",
    path: "/",
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 20101,
        title: "Block Leave Record",
        icon: "",
        path: "/block-leave-record",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 20102,
        title: "Subordinate Block Leave Record",
        icon: "",
        path: "/subordinate-block-leave-record",
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  {
    id: 3,
    title: "Leave",
    path: "/",
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 301,
        title: "Leave Application",
        icon: "",
        path: "/leave-application",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 302,
        title: "Leave Balance",
        icon: "",
        path: "/leave-balance",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 303,
        title: "Leave Application On Behalf",
        icon: "",
        path: "/leave-application-on-behalf",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 304,
        title: "Subordinate Leave Application",
        icon: "",
        path: "/subordinate-leave-application",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 305,
        title: "Subordinate LeaveBalance",
        icon: "",
        path: "/subordinate-leave-balance",
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  {
    id: 4,
    title: "Roster",
    path: "/roster",
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 401,
        title: "Roster Record",
        icon: "",
        // path: "/roster-record",
        path: "/duty-roster",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 417,
        title: "Roster Form",
        icon: "",
        path: "/roster-form-record",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 418,
        title: "My Shift",
        icon: "",
        // path: "/my-shift",
        path: "/my-roster", //我的工作安排
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  {
    id: 5,
    title: "Claim",
    path: "/claim",
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 502,
        title: "Claim Application",
        icon: "",
        path: "/claim-application",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 503,
        title: "Claim Balance",
        icon: "",
        path: "/claim-balance",
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  {
    id: 6,
    title: "Approval",
    path: "/approval",
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 403,
        title: "Approval Record",
        icon: "",
        path: "/my-approval",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 404,
        title: "Approval OnBehalf Application",
        icon: "",
        path: "/delegated-approval-record",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 406,
        title: "Approval OnBehalf Setting Application",
        icon: "",
        path: "/approval-delegation",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 405,
        title: "Approval OnBehalf Received Application",
        icon: "",
        path: "/approval-onbehalf-received-application",
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  {
    id: 7,
    title: "Application",
    path: "/my-application",
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 408,
        title: "My Application",
        icon: "",
        path: "/my-application",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 410,
        title: "Application On Behalf",
        icon: "",
        path: "/my-onbehalf-application",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 411,
        title: "Custom Form Record",
        icon: "",
        path: "/custom-form-record",
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  {
    id: 8,
    title: "Attendance",
    path: "/my-attendance", //我的考勤
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 411,
        title: "My Attendance",
        icon: "",
        // path: "/my-attendance",
        path: "/my-attendance", //我的考勤
        meta: { icon: "", isSvg: false },
      },
      {
        id: 412,
        title: "Subordinate Attendance",
        icon: "",
        path: "/subordinate-attendance",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 413,
        title: "AttendanceRecord Modification Application",
        icon: "",
        path: "/attendance-modification",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 414,
        title: "Abnormal Clock-in",
        icon: "",
        // path: "/abnormal-clockin",
        path: "/abnormal-clock-in",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 415,
        title: "Punch Record",
        icon: "",
        path: "/clock-in",
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  {
    id: 9,
    title: "Announcement",
    path: "/company-announcement",
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 901,
        title: "Announcement",
        icon: "",
        path: "/company-announcement",
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  {
    id: 10,
    title: "个人中心",
    meta: { icon: "", isSvg: false },
    children: [
      {
        id: 1001,
        title: "Payslip",
        path: "/pay-slip",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 1002,
        title: "Tax",
        path: "/tax-form",
        meta: { icon: "", isSvg: false },
      },
      {
        id: 1003,
        title: "Document Center",
        path: "/document-center",
        meta: { icon: "", isSvg: false },
      },
    ],
  },
  // admin
  {
    id: 1,
    title: "Admin Only",
    icon: "",
    path: "/admin",
    meta: { icon: "settings", isSvg: false },
    children: [
      // Shift
      {
        id: 102,
        title: "Shift",
        icon: "",
        children: [
          {
            id: 10201,
            title: "Shift",
            icon: "",
            path: "/admin/shift",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10202,
            title: "Shift Type",
            icon: "",
            path: "/admin/shift-type",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10203,
            title: "Shift Property Group",
            icon: "",
            path: "/admin/shift-policy",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10204,
            title: "Shift Type Mapping",
            icon: "",
            path: "/admin/staff-shift-config",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      // Event
      {
        id: 103,
        title: "Event",
        icon: "",
        children: [
          {
            id: 10301,
            title: "Event",
            icon: "",
            path: "/admin/event-management",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10302,
            title: "Event Type",
            icon: "",
            path: "/admin/event-type",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10303,
            title: "Event Property Group",
            icon: "",
            path: "/admin/event-policy",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      // Roster
      {
        id: 104,
        title: "Roster",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 10401,
            title: "Roster Form",
            path: "/admin/roster-form-template",
            meta: { icon: "", isSvg: false },
          },
          // {
          //   id: 10402,
          //   title: "Roster Form Master",
          //   path: "/admin/rosterFormMaster",
          //   meta: { icon: "", isSvg: false },
          // },
          {
            id: 10403,
            title: "Roster Template",
            path: "/admin/roster-template",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10404,
            title: "Roster Property Group",
            path: "/admin/roster-policy",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10405,
            title: "Roster Form Record",
            path: "/admin/roster-form-record",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10406,
            title: "Roster Record",
            path: "/admin/duty-schedule",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      //Site
      {
        id: 105,
        title: "Site",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 10501,
            title: "Site",
            path: "/admin/site",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10502,
            title: "Site Type",
            path: "/admin/site-type",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      //Approval
      {
        id: 106,
        title: "Approval",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 10600,
            title: "Approval Process",
            path: "/admin/approval-process",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10601,
            title: "Approval Template",
            path: "/admin/approval-template",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10602,
            title: "Approval Type",
            path: "/admin/approval-type",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10603,
            title: "Flow Template Message",
            path: "/admin/flow-template-message",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      // Block Leave
      {
        id: 1061,
        title: "Block Leave",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 106100,
            title: "Block Leave Group",
            path: "/admin/block-leave-policy",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 106101,
            title: "Block Leave Record",
            path: "/admin/block-leave-record",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 106102,
            title: "Block Leave Mapping",
            path: "/admin/block-leave-mapping",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      //Leave
      {
        id: 107,
        title: "Leave",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 10708,
            title: "Leave Application",
            path: "/admin/leave-application",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10701,
            title: "Leave Balance",
            path: "/admin/leave-balance",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10702,
            title: "Leave Reason",
            path: "/admin/leave-reason",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10703,
            title: "Leave Cancellation Reason",
            path: "/admin/leave-cancellation-reason",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10704,
            title: "Leave Transaction Property Group",
            path: "/admin/leave-transaction-policy",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10705,
            title: "Leave Type",
            path: "/admin/leave-type",
            meta: { icon: "", isSvg: false },
          },

          {
            id: 10707,
            title: "Leave Type Property Group",
            path: "/admin/leave-type-policy",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      //Claim
      {
        id: 108,
        title: "Claim",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 10801,
            title: "Claim Reason",
            path: "/admin/claim-reason",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 108020,
            title: "Claim Balance",
            path: "/admin/claim-balance",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10802,
            title: "Claim Record",
            path: "/admin/claim-record",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10803,
            title: "Claim Type",
            path: "/admin/claim-type",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10804,
            title: "Claim Item Type",
            path: "/admin/claim-item",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10805,
            title: "Claim Transaction Type Property Group",
            path: "/admin/claim-transaction-policy",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10806,
            title: "Claim Type Property Group",
            path: "/admin/claim-type-policy",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      //Punch
      {
        id: 109,
        title: "Punch",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 10901,
            title: "Punch Criteria Type",
            path: "/admin/clock-in-criteria",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10902,
            title: "Punch Management",
            path: "/admin/clock-in-management",
            meta: { icon: "", isSvg: false },
          },
          // {
          //   id: 109021,
          //   title: "Punch Manage2",
          //   path: "/admin/punchManage",
          //   meta: { icon: "", isSvg: false },
          // },
          {
            id: 10903,
            title: "Punch Record",
            path: "/admin/clock-in",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 10904,
            title: "Abnormal Clock-in",
            path: "/admin/abnormal-clock-in",
            meta: { icon: "", isSvg: false },
          },

          {
            id: 10905,
            title: "Abnormal Punch Reason",
            path: "/admin/abnormal-clock-in-reason",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      //Staff
      // {
      //   id: 1010,
      //   title: "Staff",
      //   meta: { icon: "", isSvg: false },
      //   children: [
      //     {
      //       id: 101001,
      //       title: "Staff Property",
      //       path: "/admin/staffProperty",
      //       meta: { icon: "", isSvg: false },
      //     },
      //     {
      //       id: 101002,
      //       title: "Staff Property Group",
      //       path: "/admin/staffPropertyGroup",
      //       meta: { icon: "", isSvg: false },
      //     },
      //   ],
      // },
      //Holiday
      {
        id: 1011,
        title: "Holiday",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 101101,
            title: "Public Holiday",
            path: "/admin/public-holiday",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 101102,
            title: "Public Holiday Type",
            path: "/admin/holiday-type",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 101103,
            title: "Public Holiday Group",
            path: "/admin/holiday-group",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      // Attendance
      {
        id: 1012,
        title: "Attendance",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 101201,
            title: "Attendance Record",
            path: "/admin/attendance-record",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 101202,
            title: "Attendance Modification Application",
            path: "/admin/attendance-modification",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 101203,
            title: "Attendance Modification Reason",
            path: "/admin/attendance-modification-reason",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 101204,
            title: "Attendance Internal",
            path: "/admin/attendance-internal",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 101205,
            title: "Staff Card",
            path: "/admin/staff-card",
            meta: { icon: "", isSvg: false },
          },
        ],
      },

      //Company Property
      // {
      //   id: 1013,
      //   title: "Company Property",
      //   path: "/admin/companyProperty",
      //   meta: { icon: "", isSvg: false },
      // },
      //Notification
      {
        id: 1014,
        title: "Message Type",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 10141,
            title: "Message Type",
            path: "/admin/message-type",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      {
        id: 1015,
        title: "Announcement",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 10151,
            title: "Announcement",
            path: "/admin/company-announcement",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      {
        id: 1016,
        title: "企业中心",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 101601,
            title: "Payslip",
            path: "/admin/company-management/pay-slip",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 101602,
            title: "Tax",
            path: "/admin/company-management/tax-form",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
      {
        id: 1017,
        title: "Custom Form",
        meta: { icon: "", isSvg: false },
        children: [
          {
            id: 101701,
            title: "Custom Form Type",
            path: "/admin/custom-form-type",
            meta: { icon: "", isSvg: false },
          },
          {
            id: 101702,
            title: "Custom Form Record",
            path: "/admin/custom-form-record",
            meta: { icon: "", isSvg: false },
          },
        ],
      },
    ],
  },
];
